class UiImage extends HTMLElement {
  constructor() {
    super();
    this.imageSrc = this.getAttribute('src') || '';
    this.altText = this.getAttribute('alt') || 'Hover image';
    this.imgHeight = this.getAttribute('height');
    this.imgWidth = this.getAttribute('width');
    this.hasImage = false;
    this.sizes = this.getAttribute('sizes');
    this.srcset = this.getAttribute('srcset');
    this.imageClass = 'w-full h-full object-cover opacity-0 transition-opacity duration-300';
    this.createOnHover = false;
    this.observer = null;
    this.handleMouseEnter = this.createImage.bind(this);
    this.hoverParent = null;
  }

  connectedCallback() {
    if (this.createOnHover) {
      this.setupEventListeners();
    }

    this.style.position = 'relative';
    
    this.observer = new IntersectionObserver(
      this.handleIntersectionObserver.bind(this),
      {
        root: null,
        rootMargin: '50px', 
        threshold: 0.1
      }
    );

    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }

    if (this.hoverParent) {
      this.hoverParent.removeEventListener('mouseenter', this.handleMouseEnter);
      this.hoverParent = null;
    }
  }

  setupEventListeners() {
    this.hoverParent = this.parentNode;
    
    if (this.hoverParent && !this.hasImage) {
      this.hoverParent.addEventListener('mouseenter', this.handleMouseEnter, {
        once: true,
      });
    }
  }

  createImage() {
    if (!this.hasImage) {
      this.hasImage = true;
      const img = document.createElement('img');
      img.src = this.imageSrc;
      img.alt = this.altText;
      if (this.imgWidth) img.width = this.imgWidth;
      if (this.imgHeight) img.height = this.imgHeight;
      img.className = this.imageClass;
      img.fetchPriority = 'auto';
      img.loading = 'lazy';
      if (this.sizes) img.sizes = this.sizes;
      if (this.srcset) img.srcset = this.srcset;
      
      this.appendChild(img);

      img.addEventListener('load', () => {
        img.classList.remove('opacity-0');
        img.classList.add('opacity-100', 'bg-secondary4');
      });
    }
  }

  handleIntersectionObserver(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.createImage();
        this.observer.unobserve(entry.target);
      }
    });
  }

  static get observedAttributes() {
    return ['src', 'alt'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    // ... (Keep your existing attributeChangedCallback logic here) ...
  }
}

customElements.define('ui-create-image', UiImage);